import { useEffect } from 'react'
import { getDocumentListByBook, getDocumentListByMessage } from '../../../services/sBook/document.service'

const useGetDocumentListByBook = (bookId, documentList, setDocumentLinkList, documentGetFired, setDocumentGetFired, partyMemberId) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getDocumentListByBook(bookId, partyMemberId);
                const response = serviceResponse.data;
    
                if (response.succeeded) {
                    const data = response.data.map((item, index) => {
                        item.key = item.id;
                        return item;
                    });
                    setDocumentLinkList(response.data);
                    setDocumentGetFired(false)
                }
                else {
                    setDocumentLinkList([]);
                    setDocumentGetFired(false)
                }
            }
            catch (error) {
                setDocumentLinkList([]);
                setDocumentGetFired(false)
            }
        }
        
        if ((bookId !== null && documentList === null) || documentGetFired === true) {
            getData()
        }
    }, [bookId, documentList, setDocumentLinkList, documentGetFired]);
}

const useGetDocumentListByMessageFromMessageBox = (messageId, setDocumentList, dataFilled, setDataFilled) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getDocumentListByMessage(messageId);
                const response = serviceResponse.data;
    
                if (response.succeeded) {
                    setDataFilled(true)
                    setDocumentList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: response.data
                    }));
                }
                else {
                    setDataFilled(true)
                    setDocumentList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                setDataFilled(true)
                setDocumentList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));
            }
        }
        
        if (dataFilled === false && messageId !== null) {
            getData()
        }
    }, [messageId, setDocumentList, dataFilled, setDataFilled]);
}

const useGetDocumentListByMessage = (messageId, documentList, setDocumentList, isPanelOpen, dataFilled, setDataFilled) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getDocumentListByMessage(messageId);
                const response = serviceResponse.data;
    
                if (response.succeeded) {
                    setDataFilled(true);
                    setDocumentList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: response.data
                    }));
                }
                else {
                    setDataFilled(true);
                    setDocumentList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));
                }
            }
            catch (error) {
                setDataFilled(true);
                setDocumentList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));
            }
        }
        
        if (dataFilled === false && messageId !== null && documentList.data === null && isPanelOpen) {
            getData()
        }
    }, [messageId, documentList, setDocumentList, isPanelOpen, dataFilled, setDataFilled]);
}

export {
    useGetDocumentListByMessageFromMessageBox,
    useGetDocumentListByMessage,
    useGetDocumentListByBook
}